<template>
  <div>
    <div ref="editor" :style="editorStyle"></div>
    <div v-show="false">
      <div class="w-e-menu w-e-code" ref="code" @click="handleCode" :title="(isSource ? '退出' : '') +'源码'"><i class="fa fa-fw fa-code" :class="{'active': isSource}"></i></div>
      <div class="w-e-menu w-e-fullscreen" ref="fullscreen" @click="handleFullscreen" :title="(isFullscreen ? '退出' : '') +'全屏'"><i class="fa fa-fw" :class="[isFullscreen ? 'fa-window-restore' : 'fa-window-maximize']"></i></div>
    </div>
  </div>
</template>

<script>
import E from 'wangeditor'
import { addClass, removeClass, hasClass } from 'jyutils/utils';
export default {
  name: 'JyEditor',
  componentName: 'JyEditor',
  props: {
    content: String,
    hasCode: Boolean,
    uploadImgUrl: String,
    uploadImgMaxsize: Number, // M
    uploadHeaders: Object,
    uploadParams: Object,
    imgOnLoad: Function,
    height: String,
    zIndex: Number,
    params: Object
  },
  data () {
    return {
      editor: null,
      editorContent: '',
      isSource: false,
      isFullscreen: false,
      fullClsname: 'fullscreen-editor'
    }
  },
  computed: {
    editorStyle() {
      return this.height ? {height: this.height} : {};
    }
  },
  watch: {
    content(val) {
      this.setHtml(val);
    }
  },
  mounted() {
    const self = this;
    this.editor = new E(this.$refs.editor);
    this.editor.customConfig.onchange = (html) => {
      this.editorContent = html;
      this.$emit('change', html, this.params);
    };
    this.editor.customConfig.onblur = (html) => {
      this.$emit('blur', html, this.params);
    }
    if (this.uploadImgUrl) {
      this.editor.customConfig.uploadImgServer = this.uploadImgUrl;  // 上传图片到服务器
    }
    if (this.uploadImgMaxsize) {
      this.editor.customConfig.uploadImgMaxSize = this.uploadImgMaxsize * 1024 * 1024; // 上传图片大小限制
    }
    this.editor.customConfig.withCredentials = true;
    if (this.uploadHeaders) {
      this.editor.customConfig.uploadImgHeaders = this.uploadHeaders;
    }
    if (this.zIndex) {
      this.editor.customConfig.zIndex = this.zIndex;
    }
    if (this.uploadParams) {
      this.editor.customConfig.uploadImgParams = this.uploadParams;
    }
    this.editor.customConfig.uploadImgHooks = {
      // 如果服务器端返回的不是 {errno:0, data: [...]} 这种格式，可使用该配置
      // （但是，服务器端返回的必须是一个 JSON 格式字符串！！！否则会报错）
      customInsert: function (insertImg, result/*, editor*/) {
          // 图片上传并返回结果，自定义插入图片的事件（而不是编辑器自动插入图片！！！）
          // insertImg 是插入图片的函数，editor 是编辑器对象，result 是服务器端返回的结果

          // 举例：假如上传图片成功后，服务器端返回的是 {url:'....'} 这种格式，即可这样插入图片：
          // var url = result.url
          // insertImg(url)

          // result 必须是一个 JSON 格式字符串！！！否则报错
          if (self.imgOnLoad) {
            self.imgOnLoad(result, insertImg, self);
          }
      }
    };
    this.editor.create();
    // 源码按钮
    if (this.hasCode) {
      this.addCodeMenu();
    }
    // 全屏按钮
    this.addFullscreenMenu();
    // 编辑器高度
    if (this.height) {
      const editor = this.$refs.editor;
      this.$nextTick(() => {
        let toolbar = editor.querySelector('.w-e-toolbar');
        editor.querySelector('.w-e-text-container').style.height = 'calc(100% - '+ toolbar.offsetHeight +'px)';
      });
    }
    this.$nextTick(() => {
      this.setHtml(this.content);
    });
    // 事件[同步编辑器内容]
    this.$on('jy.editor.sync', () => {
      this.blur();
    });
  },
  methods: {
    setHtml(html) {
      setTimeout(() => {
        this.editor.txt.html(html || '');
      }, 100);
    },
    getHtml() {
      return this.editor.txt.html();
    },
    blur() {
      this.$emit('blur', this.getHtml(), this.params);
    },
    addCodeMenu() {
      let toolbar = this.$refs.editor.querySelector('.w-e-toolbar');
      let menus = toolbar.querySelector('.w-e-menu');
      toolbar.insertBefore(this.$refs.code, menus);
    },
    handleCode() {
      let html = this.editor.txt.html();
      const $menus = this.$refs.editor.querySelectorAll('.w-e-toolbar > div');
      if (this.isSource) {
        $menus.forEach(el => {
          removeClass(el, 'd-none');
        });
        addClass(this.$refs.code.querySelector('i'), 'text-danger');
        this.isSource = false;
        // 
        html = this.editor.txt.text().replace(/&lt;/ig, "<").replace(/&gt;/ig, ">").replace(/&nbsp;/ig, " ");
      } else {
        $menus.forEach(el => {
          addClass(el, 'd-none');
        });
        removeClass(this.$refs.code, 'd-none');
        removeClass(this.$refs.fullscreen, 'd-none');
        this.isSource = true;
        // 
        html = html.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/ /g, "&nbsp;");
      }
      this.editor.txt.html(html);
    },
    addFullscreenMenu() {
      let toolbar = this.$refs.editor.querySelector('.w-e-toolbar');
      toolbar.appendChild(this.$refs.fullscreen);
    },
    handleFullscreen() {
      const editor = this.$refs.editor;
      if (this.isFullscreen) {
        removeClass(editor, this.fullClsname);
      } else {
        addClass(editor, this.fullClsname);
      }
      this.isFullscreen = hasClass(editor, this.fullClsname);
    }
  }
}
</script>
<style>
.w-e-toolbar {
  flex-wrap: wrap;
  -webkit-box-lines: multiple;
}
.w-e-toolbar .w-e-menu:hover{
  z-index: 10002!important;
}
.w-e-menu i.active {
  font-weight:bold;
  color:#ff6600;
}
.fullscreen-editor {
  position: fixed !important;
  width: 100% !important;
  height: 100% !important;
  left: 0px !important;
  top: 0px !important;
  background-color: white;
  z-index: 9999;
}
.fullscreen-editor .w-e-text-container {
  width: 100% !important;
  height: 95% !important;
}
</style>